var _dec, _class, _dec2, _class2;

import { Injectable } from "../inject/index.js";
import { AbstractLogger, colors, LogLevel } from "./index.js";
/**
 * Resets the console color
 */

export const Reset = '\x1b[0m';
/**
 * Black console foreground color
 */

export const FgBlack = '\x1b[30m';
/**
 * Red console foreground color
 */

export const FgRed = '\x1b[31m';
/**
 * Green console foreground color
 */

export const FgGreen = '\x1b[32m';
/**
 * Yellow console foreground color
 */

export const FgYellow = '\x1b[33m';
/**
 * Blue console foreground color
 */

export const FgBlue = '\x1b[34m';
/**
 * Magentaa console foreground color
 */

export const FgMagenta = '\x1b[35m';
/**
 * Cyan console foreground color
 */

export const FgCyan = '\x1b[36m';
/**
 * White console foreground color
 */

export const FgWhite = '\x1b[37m';
/**
 * Returns an associated color to a specific log level
 */

export const getLevelColor = function (level) {
  let isBrowser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let color;

  switch (level) {
    case LogLevel.Verbose:
      color = isBrowser ? colors.darkblue : FgBlue;
      break;

    case LogLevel.Debug:
      color = isBrowser ? colors.darkblue : FgBlue;
      break;

    case LogLevel.Information:
      color = isBrowser ? colors.darkgreen : FgGreen;
      break;

    case LogLevel.Warning:
      color = isBrowser ? colors.darkorange : FgYellow;
      break;

    case LogLevel.Error:
      color = isBrowser ? colors.darkred : FgRed;
      break;

    default:
      color = isBrowser ? colors.darkred : FgRed;
      break;
  }

  return color;
};
/**
 * The default formatter for the Console logger
 * @param entry the log entry to be formatted
 */

export const defaultFormatter = (entry, isVerbose) => {
  const fontColor = getLevelColor(entry.level);
  const formattedEntry = [`${fontColor}%s${Reset}`, entry.scope, entry.message];
  return entry.data && isVerbose ? [...formattedEntry, entry.data] : formattedEntry;
};
/**
 * The formatter for browsers like Firefox, Chrome
 * @param entry the log entry to be formatted
 */

export const browserFormatter = _ref => {
  let {
    level,
    message,
    data,
    scope
  } = _ref;

  if (!scope) {
    return data ? [message, data] : [message];
  }

  const fontColor = getLevelColor(level, true);
  const formattedEntry = [`%c[${scope}]:`, `color: ${fontColor}`, message];
  return data ? [...formattedEntry, data] : formattedEntry;
};
/**
 * A logger implementation that dumps log messages to the console
 */

export let ConsoleLogger = (_dec = Injectable({
  lifetime: 'scoped'
}), _dec(_class = class ConsoleLogger extends AbstractLogger {
  async addEntry(entry) {
    let isVerbose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const data = defaultFormatter(entry, isVerbose);
    console.log(...data);
  }

}) || _class);
export let BrowserConsoleLogger = (_dec2 = Injectable({
  lifetime: 'scoped'
}), _dec2(_class2 = class BrowserConsoleLogger extends AbstractLogger {
  async addEntry(entry) {
    const data = browserFormatter(entry);
    console.log(...data);
  }

}) || _class2);
//# sourceMappingURL=console-logger.js.map